<app-page-heading [key]="'overview.page-title'"></app-page-heading>

<section class="container-fluid">
    <div class="row">
        <div class="col-6 col-sm-4">
            <div class="ibox float-e-margins">
                <div class="ibox-title">
                    <h5 [i18n]="[{target: 'innerHTML', key: 'overview.active-users'}]"></h5>
                </div>
                <div class="ibox-content">
                    <h1 class="no-margins">{{nbActiveUsersInLast30Days}}</h1>
                </div>
            </div>
        </div>
        <div class="col-6 col-sm-4 placeholder">
            <div class="ibox float-e-margins">
                <div class="ibox-title">
                    <h5 [i18n]="[{target: 'innerHTML', key: 'overview.nb-logins-last-month'}]"></h5>
                </div>
                <div class="ibox-content">
                    <h1 class="no-margins">{{nbLoginsLastMonth}}</h1>
                </div>
            </div>
        </div>
        <div class="col-6 col-sm-4 placeholder">
            <div class="ibox float-e-margins">
                <div class="ibox-title">
                    <h5 [i18n]="[{target: 'innerHTML', key: 'overview.nb-logins-last-week'}]"></h5>
                </div>
                <div class="ibox-content">
                    <h1 class="no-margins">{{nbLoginsLastWeek}}</h1>
                </div>
            </div>
        </div>
    </div>
</section>
